import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { IResponseDto } from '@models/exceptions/response-dto';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UseTermsService {
  private url: string = environment.apiUrl + "/v1/termo";

  constructor(
    private httpClient: HttpClient
  ){}

  getUseTerms$(terNrId?: number): Observable<IUseTermDto>{
    return this.httpClient.get<IResponseDto<IUseTermDto>>(`${this.url}/${terNrId}`).pipe(
      map(res => res.response)
    )
  }
}

export interface IUseTermDto{
  terNrId: number;
  terTxTexto: string;
}

export enum TermTypeEnum{
  TERMO_USO_CADASTRAL = 'TERMO_USO_CADASTRAL'
}

